import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-single-wishlist',
  templateUrl: './single-wishlist.component.html',
  styleUrls: ['./single-wishlist.component.css']
})
export class SingleWishlistComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
